import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Globe16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_339)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 8V8.00104C0.250561 12.2808 3.72014 15.75 8 15.75C12.2802 15.75 15.75 12.2802 15.75 8C15.75 3.71979 12.2802 0.25 8 0.25C3.71979 0.25 0.25 3.71979 0.25 8ZM8 1.75C7.01975 1.75 6.09221 1.97567 5.26649 2.37789C5.9333 2.59919 6.73744 2.89503 7.24002 3.41334C8.02021 4.21794 7.4451 5.17746 6.62548 5.63925C6.21328 5.88455 5.79437 6.12455 5.40267 6.40231C5.75478 6.41526 6.10696 6.40001 6.45898 6.42114C6.89979 6.44758 7.48402 6.52873 7.96186 6.88367C8.49273 7.27799 8.75 7.89496 8.75 8.6737C8.75 9.86608 8.40196 11.1472 8.01095 12.264C7.80334 12.8977 7.08711 13.2408 6.46311 13.0053C5.73586 12.7307 5.36384 11.7087 4.88541 11.1976C4.45993 10.7431 4.04806 10.4999 3.625 10.4999C3.06706 10.4999 2.59166 10.429 2.18896 10.3055C3.1065 12.6162 5.36245 14.25 8 14.25C9.64587 14.25 11.1432 13.6138 12.2593 12.5739C12.5824 11.9153 12.5779 11.529 12.5148 11.3006C12.3154 10.5788 11.3622 10.214 10.8175 9.80584C10.4588 9.53698 9.96502 9.09703 9.90525 8.40406C9.7994 7.61387 10.0297 6.80969 10.6072 6.23217C11.0761 5.76333 11.712 5.49994 12.375 5.49994H13.7299C12.7655 3.29259 10.5629 1.75 8 1.75ZM14.1704 6.99994H12.375C11.8332 6.99994 11.3791 7.45061 11.375 7.99233C11.3929 8.68308 12.3905 9.02532 12.8712 9.40025C13.1909 9.64958 13.5335 9.97521 13.7666 10.4144C14.078 9.67156 14.25 8.85587 14.25 8C14.25 7.65961 14.2228 7.32557 14.1704 6.99994ZM1.75001 7.98643C1.75372 6.24126 2.4727 4.66403 3.62936 3.53233C4.43923 3.6414 5.21075 3.9346 5.93465 4.30609C5.30695 4.67921 4.59759 5.03037 4.07788 5.55454C3.63051 6.00575 3.54708 6.59865 3.82918 7.16286C4.51529 8.53507 6.1208 7.38467 7.06743 8.08782C7.70157 8.55886 6.9515 10.6163 6.781 11.1927C6.56294 10.8777 6.28725 10.5003 5.98052 10.1726C5.4457 9.6012 4.66319 8.99994 3.625 8.99994C2.96527 8.99994 1.84153 8.8415 1.75086 7.99524L1.75001 7.98643Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_339'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Globe16.displayName = 'Globe16';
export default Globe16;
